import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {plainToClass, plainToClassFromExist} from "class-transformer";
import {environment} from "../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {QueryParamsApiModel} from "../models/query-params-api.model";
import {QueryParamsService} from "../../core/services/query-params.service";
import {ResultListApiModel} from "../models/result-list.api.model";
import {ConversationApiModel} from "../models/conversation.api.model";

@Injectable({
  providedIn: 'root'
})
export class ConversationRestService {
  private readonly resource: string = '/conversations';

  constructor(
    private http: HttpClient,
    private params: QueryParamsService
  ) {
  }

  public get(conversationId: string): Observable<ConversationApiModel> {
    return this.http.get<ConversationApiModel>(environment.apiUrl + conversationId)
      .pipe(map(result => plainToClass(ConversationApiModel, result)));
  }

  public getCollection(
    queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel(),
    headers?: HttpHeaders
  ): Observable<ResultListApiModel<ConversationApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<ConversationApiModel>>(environment.apiUrl + this.resource, {params, headers})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<ConversationApiModel>(ConversationApiModel), result as object)));
  }

  public markRead(conversationId: string, lastMessage?: string): Observable<ConversationApiModel> {
    return this.http.post<ConversationApiModel>(environment.apiUrl + conversationId + '/read', {
      lastMessage
    }).pipe(map(result => plainToClass(ConversationApiModel, result)));
  }

  public touchPresence(conversationId: string): Observable<void> {
    return this.http.post<void>(environment.apiUrl + conversationId + '/presence', {});
  }

  public clearPresence(): Observable<void> {
    return this.http.post<void>(environment.apiUrl + this.resource + '/presence/clear', {});
  }

  public getUnreadCount(): Observable<number> {
    const headers = new HttpHeaders({'x-cache-refresh': 'true'});
    return this.http.get<{count: number}>(environment.apiUrl + this.resource + '/unread-count', {headers})
      .pipe(map(result => result.count ?? 0));
  }
}
